export default class OrderHistoryFilter {
	constructor() {
		this.form = document.getElementById('orderHistoryFilter');
		this.searchBySelect = document.getElementById('searchBySelect');
		this.dateFilterSelect = document.getElementById('dateFilterSelect');
		this.searchByInputSection = document.getElementById(
			'orderHistorySearchByInput',
		);
		this.searchByInput =
			this.searchByInputSection?.querySelector('#searchByInput');
		this.addressInputsSection = document.getElementById(
			'orderHistoryAddressInputs',
		);
		this.isShippingAddressSelected = this.getIsShippingAddressSelected(
			this.searchBySelect.dataset.selectedValue,
		);

		this.init();
	}

	init() {
		const { OdSelect } = window.od;
		new OdSelect(this.searchBySelect);
		new OdSelect(this.dateFilterSelect);
		this.searchBySelect.onchange =
			this.handleSearchByCriteriaSelection.bind(this);
		this.form.onsubmit = this.submit.bind(this);
	}

	handleSearchByCriteriaSelection({ detail }) {
		const { value } = detail;
		this.isShippingAddressSelected = this.getIsShippingAddressSelected(value);
		this.removeAttributes(this.searchByInput, 'disabled', 'readonly');
		this.setInputsVisibilityState(this.isShippingAddressSelected);
	}

	removeAttributes(element, ...attributes) {
		attributes.forEach(attribute => {
			element.removeAttribute(attribute);
		});
	}

	setInputsVisibilityState(isShippingAddressSelected) {
		this.searchByInputSection.toggleAttribute(
			'hidden',
			isShippingAddressSelected,
		);
		this.addressInputsSection.toggleAttribute(
			'hidden',
			!isShippingAddressSelected,
		);
	}

	submit(event) {
		if (!this.isShippingAddressSelected) return;
		event.preventDefault();
		this.searchByInput.value = this.buildAddressString();
		this.form.submit();
	}

	buildAddressString() {
		const addressInputs = [
			...this.addressInputsSection.querySelectorAll('input'),
		];
		// building address string into the next format to reuse existing filtering functionality on BE -
		// address-line-value|city-value|postal-code-value
		// | - separation symbol
		const { value: lastAddressInputValue } = addressInputs.pop();
		const addressString = addressInputs.reduce(
			(string, { value }) => `${string}${value}|`,
			'',
		);
		return `${addressString}${lastAddressInputValue}`;
	}

	getIsShippingAddressSelected(value) {
		return value === 'SHIPPING_ADDRESS';
	}
}
